import { render, staticRenderFns } from "./TypeTest.vue?vue&type=template&id=3b29ac4d&scoped=true&"
import script from "./TypeTest.vue?vue&type=script&lang=js&"
export * from "./TypeTest.vue?vue&type=script&lang=js&"
import style0 from "./TypeTest.vue?vue&type=style&index=0&id=3b29ac4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29ac4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VOtpInput,VRow})
